import { render, staticRenderFns } from "./PlaylistContentPanel.vue?vue&type=template&id=21a67e8c&scoped=true&"
import script from "./PlaylistContentPanel.vue?vue&type=script&lang=ts&"
export * from "./PlaylistContentPanel.vue?vue&type=script&lang=ts&"
import style0 from "./PlaylistContentPanel.vue?vue&type=style&index=0&id=21a67e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a67e8c",
  null
  
)

export default component.exports